import { render, staticRenderFns } from "./PersonalPropertyThirdPartyProductCandidates.vue?vue&type=template&id=f510d3ac&scoped=true"
import script from "./PersonalPropertyThirdPartyProductCandidates.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyThirdPartyProductCandidates.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyThirdPartyProductCandidates.vue?vue&type=style&index=0&id=f510d3ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f510d3ac",
  null
  
)

export default component.exports